import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';
import { space, typography, SpaceProps, TypographyProps } from 'styled-system';

export const StyledContainer = styled.div`
  position: relative;
  width: min(658px, 100vw - 40px);
  height: auto;
  min-height: auto;
  display: flex;
  flex-direction: column;
`;

export const StyledSection = styled.section<SpaceProps>`
  padding: 65px 100px;
  overflow: visible;
  background-color: ${themeGet('colors.white')};
  border-radius: ${themeGet('radii.base')};
  height: auto;
  min-height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;

  ${space}
`;

type HeadingProps = SpaceProps & TypographyProps;

export const StyledHeading = styled.h4<HeadingProps>`
  text-align: center;
  font-weight: ${themeGet('fontWeights.regular')};
  color: ${themeGet('colors.text.default')};
  margin-bottom: 34px;

  ${typography}
  ${space}
`;
export const StyledHeadingWithOutMargin = styled.h4<HeadingProps>`
  text-align: center;
  font-weight: ${themeGet('fontWeights.bold')};
  color: ${themeGet('colors.text.default')};
  
  ${typography}
  ${space}
`;

export const StyledTitle = styled.h5<{
  bold?: boolean;
}>`
  font-weight: ${(props) =>
    props?.bold ? themeGet('fontWeights.bold') : themeGet('fontWeights.semi')};
  color: ${themeGet('colors.text.default')};

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const StyledSubTitle = styled.div<{
  secondary?: boolean;
}>`
  font-size: ${themeGet('fontSizes.sm')}px;
  color: ${(props) =>
    props?.secondary
      ? themeGet('colors.primary.regular')
      : themeGet('colors.text.default')};

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const StyledTextRight = styled.span`
  display: block;
  margin-bottom: 3px;
  text-align: right;
  line-height: 16px;
  color: ${themeGet('colors.text.default')};
  font-size: ${themeGet('fontSizes.xs')}px;
  font-weight: ${themeGet('fontWeights.bold')};
`;

export const StyledSemi = styled.b`
  font-weight: ${themeGet('fontWeights.semi')};
`;
export const StyledSemiTerms = styled.p`
  font-weight: ${themeGet('fontWeights.semi')};
  font-size: ${themeGet('fontSizes.up')}px;
  color: ${themeGet('colors.text.default')};
  margin-bottom: 34px;


`;
type DescProps = TypographyProps & SpaceProps;

export const StyledDesc = styled.p<DescProps>`
  font-size: ${themeGet('fontSizes.sm')}px;
  font-weight: ${themeGet('fontWeights.regular')};
  margin-bottom: 1rem;
  ${space}
  ${typography}
`;
export const StyledDescUpper = styled.span`
  text-transform: uppercase;
`;

export const StyledParagraph = styled.li`
  padding-left: 7px;
  list-style: auto;
`;
export const StyledList = styled.ol`
`;
export const StyledArticle = styled.div<{
  upper?: boolean;
}>`
  font-size: ${themeGet('fontSizes.sm')}px;
  font-weight: ${themeGet('fontWeights.regular')};
  margin-bottom: 30px;
  line-height:1.9;
  &>p{
    color: ${themeGet('colors.text.default')};
  }
  
  ${space}
  ${typography}
`;
export const StyledTotal = styled.div`
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: ${themeGet('fontWeights.semi')};
  color: ${themeGet('colors.text.default')};

  &:not(:last-child) {
    margin-bottom: 31px;
  }
`;

export const StyledTotalText = styled.h5`
  margin-right: 10px;
  font-size: 20px;
`;

export const StyledTotalValue = styled.span`
  color: ${themeGet('colors.primary.regular')};
`;

export const StyledText = styled.p`
  font-size: ${themeGet('fontSizes.sm')}px;
  font-weight: ${themeGet('fontWeights.regular')};
  color: ${themeGet('colors.text.default')};

  &:not(:last-child) {
    margin-bottom: 34px;
  }

  > .custom-checkbox {
    display: inline-block;
    margin-left: 10px;
    vertical-align: middle;
  }
`;
export const StyledTextCheckbox = styled.p`
  font-size: ${themeGet('fontSizes.sm')}px;
  font-weight: ${themeGet('fontWeights.regular')};
  color: ${themeGet('colors.primary.regular')};

  &:not(:last-child) {
    margin-bottom: 34px;
  }

  > .custom-checkbox {
    display: inline-block;
    margin-left: 10px;
    vertical-align: middle;
  }
`;

export const StyledLink = styled.a`
  font-weight: ${themeGet('fontWeights.semi')};
  text-decoration: underline;
  color: #000;

  &:hover {
    color: ${themeGet('colors.linkColor')};
  }
`;

export const StyledAmount = styled.span`
  margin-left: 20px;
  font-size: 20px;
  color: ${themeGet('colors.primary.regular')};
  font-weight: ${themeGet('fontWeights.bold')};
`;

type AmountProps = SpaceProps & {
  mb?: number;
};
export const StyledBlockWithScroll = styled.div<AmountProps>`
  max-height: 530px;
  overflow-y:scroll ;
`;
export const StyledAmountWrapper = styled.div<AmountProps>`
  display: grid;
  grid-template-columns: 1fr 2fr;

  ${space}
`;

export const StyledFlex = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 25px;
  }

  h4 {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: ${themeGet('fontWeights.bold')};

    .custom-tooltip {
      margin-left: 10px;
    }
  }
`;
